module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ie-0542b94612db83a2f5502811528ac249.svg";